import { useMutation } from 'apollo-3';

import { createPendingFreeTrialRedemption } from 'GraphQL/mutation/Enrollment.mutation';

const useCreateFreeTrialEnrollment = (props) => {
  const [createFreeTrialEnrollment, { data, loading, error, ...apolloUtils }] = useMutation(
    createPendingFreeTrialRedemption,
    { ...props }
  );

  return {
    mutate: createFreeTrialEnrollment,
    loading,
    error,
    ...apolloUtils,
  };
};

export default useCreateFreeTrialEnrollment;
